<template>
  <div class="modal warning fade" :class="{'is-open': open}">
    <div class="modal-dialog modal-sm">
      <div class="modal-content">
        <div class="modal-body">
          <h4 class="warning mt-0 mb-5" v-html="message"></h4>
          <div class="action">
            <a @click="$emit('close')" class="btn btn-block btn-primary">關閉</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'WarningModal',
  props: {
    open: {
      type: Boolean,
      default: false
    },
    message: {
      type: String,
      default: ''
    }
  },
  watch: {
     message () {
        this.registerHanlink()
      },
  }
}
</script>
